import React, {useState} from 'react';
import Button from '@mui/material/Button';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import {downloadAuthenticatedFile, isStoredFile} from '../helpers/authenticatedFile';

// A download button that carries the caller's token.
//
// The report used to be an <a href>, which the browser follows without an
// Authorization header. Now that the route is guarded, following that link would
// open a 401 in a new tab, so the file is fetched and handed to the browser as a
// blob. Remote URLs still open in a new tab, which is all they ever did.
const AuthenticatedDownloadButton = ({url, filename, label, ...props}) => {
    const [state, setState] = useState('idle');

    const handleClick = async () => {
        if (!isStoredFile(url)) {
            window.open(url, '_blank', 'noopener');
            return;
        }

        setState('loading');
        try {
            await downloadAuthenticatedFile(url, filename);
            setState('idle');
        } catch (e) {
            setState('failed');
        }
    };

    return (
        <Button
            startIcon={<CloudDownloadOutlinedIcon />}
            variant="outlined"
            color="primary"
            onClick={handleClick}
            disabled={state === 'loading'}
            {...props}
        >
            {state === 'loading' ? 'Preparing…' : (state === 'failed' ? 'Download failed' : label)}
        </Button>
    );
};

export default AuthenticatedDownloadButton;